package songwritersnotebook.app.utils

import songwritersnotebook.app.data.GuitarTab

object TabTextFormatter {

    fun formatTabToText(tab: GuitarTab): String {
        val sbInst = StringBuilder("Inst: ")
        val sbE = StringBuilder("e|    ")
        val sbB = StringBuilder("B|    ")
        val sbG = StringBuilder("G|    ")
        val sbD = StringBuilder("D|    ")
        val sbA = StringBuilder("A|    ")
        val sbE_low = StringBuilder("E|    ")

        val builders = listOf(sbE, sbB, sbG, sbD, sbA, sbE_low)

        tab.columns.forEachIndexed { index, col ->
            if (index > 0 && index % tab.subdivisions == 0) {
                sbInst.append("|")
                builders.forEach { it.append("|") }
            }

            val instructionLen = col.instruction.length
            val notesMaxLen = col.notes.maxOfOrNull { it.length } ?: 1
            val colWidth = maxOf(instructionLen, notesMaxLen, 1)

            val inst = col.instruction.ifEmpty { "" }
            sbInst.append(inst.padEnd(colWidth, ' '))
            sbInst.append(" ")

            col.notes.forEachIndexed { i, note ->
                val noteStr = if (note.isBlank() || note == "-") "-" else note
                builders[i].append(noteStr.padEnd(colWidth, '-'))
                builders[i].append("-")
            }
        }

        sbInst.append("|")
        builders.forEach { it.append("|") }

        return buildString {
            if (tab.name.isNotBlank()) appendLine(tab.name)
            appendLine(sbInst.toString())
            builders.forEach { appendLine(it.toString()) }
        }
    }
}
